<ng-container *ngIf="isAnalystStudio$ | async; then analystStudioNav; else modeNav"> </ng-container>
<ng-template #modeNav>
  <div class="nav-account" [matMenuTriggerFor]="menu">
    <mode-workspace-avatar
      *ngIf="currentOrg"
      shape="circle"
      [type]="currentOrg.avatar.type"
      [initials]="currentOrg.avatar.initials"
      [colorClass]="currentOrg.avatar.colorClass"
      [imageSrc]="currentOrg.avatar.href"
      [imageName]="currentOrg.name"
      [isCommunity]="currentOrg.user"
    ></mode-workspace-avatar>
    <div class="nav-account-menu-body">
      <div class="mode-nav-header nav-account-orgname" data-test="workspace-name">
        {{ currentOrg?.displayName || currentOrg?.username }}
      </div>
      <div class="nav-account-username">{{ currentUser?.displayName || currentUser?.username }}</div>
    </div>
    <div class="nav-dropdown" data-test="nav-account-dropdown">
      <capra-icon icon="icon-caret-down"></capra-icon>
    </div>
  </div>
</ng-template>
<ng-template #analystStudioNav>
  <div class="account-nav" [matMenuTriggerFor]="menu">
    <div class="mode-nav-header">{{ appName }}</div>
    <div class="account-nav-right">
      <mode-workspace-avatar
        *ngIf="currentOrg"
        shape="circle"
        [type]="currentOrg.avatar.type"
        [initials]="currentOrg.avatar.initials"
        [colorClass]="currentOrg.avatar.colorClass"
        [imageSrc]="currentOrg.avatar.href"
        [imageName]="currentOrg.name"
        [isCommunity]="currentOrg.user"
      ></mode-workspace-avatar>
      <div class="nav-dropdown" data-test="nav-account-dropdown">
        <capra-icon class="nav-dropdown-caret-down" icon="icon-caret-down"></capra-icon>
      </div>
    </div>
  </div>
</ng-template>
<mat-menu class="nav-account-menu" [overlapTrigger]="true" #menu="matMenu">
  <div class="account-info">
    <mode-workspace-avatar
      *ngIf="currentOrg"
      shape="circle"
      [type]="currentOrg.avatar.type"
      [initials]="currentOrg.avatar.initials"
      [colorClass]="currentOrg.avatar.colorClass"
      [imageSrc]="currentOrg.avatar.href"
      [imageName]="currentOrg.name"
      [isCommunity]="currentOrg.user"
    ></mode-workspace-avatar>
    <div class="nav-account-menu-body" [class.analyst-studio]="isAnalystStudio$ | async">
      <div class="nav-account-orgname">
        {{ currentOrg?.displayName || currentOrg?.username }}
      </div>
      <div class="nav-account-username">{{ currentUser?.displayName || currentUser?.username }}</div>
    </div>
    <div class="nav-dropdown" *ngIf="(isAnalystStudio$ | async) === false">
      <a
        role="button"
        class="context-label"
        [class.analyst-studio]="isAnalystStudio$ | async"
        (click)="openContextDialog()"
        >Switch</a
      >
    </div>
  </div>
  <hr />
  <div class="link-list" [class.analyst-studio]="isAnalystStudio$ | async">
    <a [href]="'/organizations/' + currentOrg?.username" target="_self" class="nav-account-menu-item" mat-menu-item>
      Workspace settings
    </a>

    <!-- Data connection use cases: -->
    <!-- 1. Community org -->
    <!-- 1a. Has member orgs (switch org dialog)-->
    <!-- 1b. Doesn't have member orgs (create a new org) -->
    <!-- 2. Mode org -->
    <!-- 2a. Can connect db (connect a database page)-->
    <!-- 2b. Can't connect db (email an admin dialog) -->
    <ng-container *ngIf="isCommunityOrg; else modeOrg">
      <button
        *ngIf="hasMemberOrgs$ | async; else noMemberOrgs"
        class="nav-account-menu-item"
        mat-menu-item
        (click)="openConnectDataSourceDialog()"
      >
        Connect a Database&hellip;
      </button>
      <ng-template #noMemberOrgs>
        <button class="nav-account-menu-item" mat-menu-item (click)="openSwitchToModeStudioDialog()">
          Connect a Database&hellip;
        </button>
      </ng-template>
    </ng-container>
    <ng-template #modeOrg>
      <a
        *ngIf="canConnectDb; else emailAnAdmin"
        class="nav-account-menu-item"
        mat-menu-item
        [modeLegacyRouterLink]="currentOrg?.links.datasource"
        [queryParams]="{ flow: 'context_switch', trk_element_id: connectDatabaseElementId }"
        target="_self"
      >
        Connect a Database&hellip;
      </a>
      <ng-template #emailAnAdmin>
        <button class="nav-account-menu-item" mat-menu-item (click)="openEmailAnAdminDialog()">
          Connect a Database&hellip;
        </button>
      </ng-template>
    </ng-template>

    <a
      *ngIf="isNotThoughtspotIntegrated$ | async"
      [href]="'/' + currentOrg?.username + '/invites/new'"
      target="_self"
      class="nav-account-menu-item"
      mat-menu-item
    >
      Invite to {{ appName }}&hellip;
    </a>
    <a
      *ngIf="isNotThoughtspotIntegrated$ | async"
      href="/settings"
      target="_self"
      class="nav-account-menu-item"
      mat-menu-item
    >
      My Account settings
    </a>
    <a href="/signout" class="nav-account-menu-item" rel="nofollow" data-method="post" target="_self" mat-menu-item>
      Sign out
    </a>
  </div>
</mat-menu>
